<template>
  <b-container fluid>
    <div class="tabela">
      <b-row align-h="center"
        ><CardPalestra :palestra="palestra" disabled
      /></b-row>
      <b-row>
        <b-col>
          <div class="dados">
            <h5 class="inscritos">Inscritos na palestra: {{ items.length }}</h5>
          </div>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <ButtonFill @click="exportarCsv" texto="Exportar CSV" />
        <ButtonFill
          @click="selecionarCSVPresencas"
          texto="Importar CSV de presenças"
        /><input
          type="file"
          id="csv-file"
          style="display:none"
          accept=".csv"
        /><CPFSuggestionsModal
          :cpfs="cpfs"
          :idPalestra="$route.params.idPalestra"
        />
      </b-row>
      <b-row align-h="center"
        ><p>
          Obs.: Na importação do CSV o arquivo deve conter separadores de ',' e
          '\r\n' para pular linha
        </p></b-row
      >
      <b-table
        class="mt-3 mb-5"
        responsive
        :items="items"
        :fields="fields"
        caption-top
        hover
        bordered
        fixed="true"
        boordeless="true"
        outlined="true"
      ></b-table>
    </div>
  </b-container>
</template>

<script>
import ButtonFill from "@/components/Button-fill.vue";
import { listarInscritos } from "@/services/api/Palestra";
import CPFSuggestionsModal from "../../components/Admin/InscritosPalestra/CPFSuggestionsModal.vue";
import {
  exportarCsvInscritosPalestra,
  palestraById,
} from "../../services/api/Palestra";
import { importarCSV } from "../../services/api/Presenca";
import CardPalestra from "../../components/CardPalestra.vue";
import FileHelper from "../../utils/FileHelper";

export default {
  components: {
    ButtonFill,
    CPFSuggestionsModal,
    CardPalestra,
  },
  data() {
    return {
      fields: [
        { label: "Nome", key: "user.name", thClass: "th-label" },
        { label: "CPF", key: "user.cpf", thClass: "th-label" },
        { label: "Email", key: "user.email", thClass: "th-label" },
        { label: "Matrícula", key: "user.studentCode", thClass: "th-label" },
        {
          label: "Estava presencial",
          key: "userWasPresent",
          thClass: "th-label",
        },
      ],
      items: [],
      cpfs: [],
      palestra: {},
    };
  },
  beforeCreate() {
    const idPalestra = this.$route.params.idPalestra;
    listarInscritos(idPalestra).then((res) => {
      this.items = res.data.inscritos;
    });
    palestraById(idPalestra).then((res) => {
      this.palestra = res.data;
    });
  },
  methods: {
    exportarCsv() {
      const idPalestra = this.$route.params.idPalestra;
      exportarCsvInscritosPalestra(idPalestra)
        .then((res) => {
          const response = res.data;
          FileHelper.salvarArquivo(
            response.csv,
            response.mimeType,
            response.fileName
          );
        })
        .catch((err) => {
          alert(
            `Erro ao exportar CSV: ${JSON.stringify(
              err?.response?.data || err
            )}`
          );
        });
    },
    selecionarCSVPresencas() {
      const inputElement = document.getElementById("csv-file");
      inputElement.addEventListener("change", this.enviarCSV, false);

      inputElement.click();
    },
    async enviarCSV(event) {
      const idPalestra = this.$route.params.idPalestra;
      const csv = event.target.files[0];

      try {
        const { data } = await importarCSV(idPalestra, csv);

        this.$bvToast.toast(`${data.subscriptionsAmount} receberam presença`, {
          title: "Sucesso",
          variant: "success",
          autoHideDelay: 5000,
        });

        if (data.usersNotRegistered) {
          this.cpfs = data.notRegisteredSuggestions;
          setTimeout(() => {
            this.$bvModal.show(this.$route.params.idPalestra);
          }, 200);
        }
        listarInscritos(idPalestra).then((res) => {
          this.items = res.data.inscritos;
        });
      } catch ({ response }) {
        this.$bvToast.toast(response.message, {
          title: "Erro",
          variant: "danger",
          autoHideDelay: 5000,
        });
      }

      event.target.value = "";
    },
  },
  computed: {
    inscritosUfla() {
      return this.items.filter((item) => item.user.estudanteUfla).length;
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Roboto+Condensed");

html,
body {
  font-family: "Roboto Condensed", sans-serif;
}

.inscritos {
  display: inline;
  font-size: 40px;
  font-weight: 400;
}

.ufla {
  padding-left: 100px;
}

.dados {
  margin-bottom: 50px;
}

.tabela {
  padding: 5%;
  padding-top: 10%;
  font-weight: 400;
  font-size: 1em;
}

.botao {
  margin-left: 400px;
}
</style>

<style lang="scss" scoped>
tbody {
  tr {
    td {
      text-align: center;
      justify-content: center;
    }
  }
}

.th-label {
  font-weight: 500;
  font-size: 28px;
  text-align: center;
  justify-content: center;
}

.table-bordered th,
.table-bordered td {
  border: none;
}
</style>
